module.exports = __webpack_public_path__ + "static/media/favicon.5493dcc6.ico";